import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfigService } from 'src/services/config.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'onstream-admin';

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(
    private config: ConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title)
    {
      // idle.setIdle(900);
      // idle.setTimeout(25);
      // idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      // idle.onIdleEnd.subscribe(() => {
      //   this.idleState = 'No longer idle.'
      //   //console.log(this.idleState);
      // });

      // idle.onTimeout.subscribe(() => {
      //   this.idleState = 'Timed out';
      //   this.timedOut = true;
      //   //console.log(this.idleState);
      //   this.router.navigate(['/login']);
      // });

      // idle.onIdleStart.subscribe(() => {
      //   this.idleState = "You've gone idle";
      //   //console.log(this.idleState);
      //   // this.childModal.show();
      // });

      // idle.onTimeoutWarning.subscribe((countdown) => {
      //   this.idleState = 'You will time out in ' + countdown + ' seconds';
      //   //console.log(this.idleState);
      // });

      // keepalive.interval(60);
      // keepalive.onPing.subscribe(() => this.lastPing = new Date());

      // this.reset();
    }

  // reset() {
  //   this.idle.watch();
  //   this.idleState = 'Started';
  //   this.timedOut = false;
  // }

  ngOnInit(): void {
    // //console.log(this.config.json);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title)});
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if(activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
